import { MenuProps } from "@/layout/Navbar/Side/SideDrawer";

export const mainLayananNavMenus: MenuProps[] = [
  {
    title: "Pelayanan Sirkulasi",
    path: "/pelayanan-sirkulasi"
  },
  {
    title: "Peminjaman Bahan Pustaka",
    path: "/peminjaman"
  },
  {
    title: "Surat Bebas Perpustakaan",
    path: "/sbp"
  }
];